import { render, staticRenderFns } from "./sales-contract-list.vue?vue&type=template&id=bd3cff84"
import script from "./sales-contract-list.vue?vue&type=script&lang=js"
export * from "./sales-contract-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports